import DropDownViewModel from "../../../../Utilities/ViewModels/DropDownViewModel";

const formatTimeLabel = (timeIndex: number) => {
    const totalMinutes = timeIndex * 30;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};

export const buildMonitoringReportEndTimeOptions = (surveyTimesDropdown: DropDownViewModel[]) => {
    if (surveyTimesDropdown.length === 0) {
        return [];
    }

    return surveyTimesDropdown.map((option, index) => {
        const currentId = Number(option.id);
        const nextId = Number(surveyTimesDropdown[index + 1]?.id);
        const previousId = Number(surveyTimesDropdown[index - 1]?.id);

        const increment = Number.isFinite(nextId)
            ? nextId - currentId
            : Number.isFinite(previousId)
                ? currentId - previousId
                : 2;

        return {
            ...option,
            label: formatTimeLabel(currentId + increment)
        };
    });
};
